import { createContext, useCallback, useContext, useReducer } from 'react';

const AuthenticatedContext = createContext(null);
const AuthenticatedDispatchContext = createContext(null);

const initialAuthenticated = { authenticated: false };

function authenticatedReducer(state, action) {
  switch (action.type) {
    case 'update': {
      return { ...state, authenticated: !!action.payload };
    }
  }
  return state;
}

export function AuthenticatedProvider({ children }) {
  const [state, dispatch] = useReducer(authenticatedReducer, initialAuthenticated);
  return (
    <AuthenticatedContext.Provider value={state}>
      <AuthenticatedDispatchContext.Provider value={dispatch}>
        {children}
      </AuthenticatedDispatchContext.Provider>
    </AuthenticatedContext.Provider>
  );
}

export function useIsAuthenticated() {
  const state = useContext(AuthenticatedContext);
  return !!state.authenticated;
}

export function useSetAuthenticated() {
  const dispatch = useContext(AuthenticatedDispatchContext);
  return useCallback((value) => dispatch({ type: 'update', payload: value }), [dispatch]);
}
